import { getClientIp } from "./getClientIp";

export const getDeviceInfo = async () => {
  const deviceId =
    localStorage.getItem("device_id") ||
    localStorage.getItem("deviceid") ||
    `web_${Date.now()}`;

  if (!localStorage.getItem("device_id")) {
    localStorage.setItem("device_id", deviceId);
  }
  if (!localStorage.getItem("deviceid")) {
    localStorage.setItem("deviceid", deviceId);
  }

  const ipAddress = await getClientIp();

  return {
    device_id: deviceId,
    deviceid: deviceId,
    device_type: "web",
    os_version: (typeof navigator !== "undefined" && (navigator.userAgentData?.platform || navigator.platform)) || "windows",
    app_version: "1.0.0",
    fcm_token: null,
    ip_address: ipAddress || "",
  };
};
